import { reduceMotion } from '@js/animations/ReducedMotion'
import { createOnceOnEnter } from '@js/animations/scrollTriggerHelper'

export class Zoom {
  constructor () {
    this._elements = document.querySelectorAll('[animation-zoom]')

    if (!this._elements.length) {
      return
    }

    this.init()
  }

  init () {
    this._elements.forEach((el) => {
      const type = el.getAttribute('animation-zoom')

      if (reduceMotion) {
        el.classList.add('animation-zoom-' + type + '--active')
        return
      }

      createOnceOnEnter({
        trigger: el,
        onEnter: () => {
          el.classList.add('animation-zoom-' + type + '--active')
        },
      })
    })
  }
}
